<template>
    <div class="other-Assets">
        <div class="head">
            <div class="main">
                <div v-if="ftype == '3'">普洛斯现代物流产业资产</div>
                <div v-if="ftype == '2'">天瓴资产</div>
                <div v-if="ftype == '1'">喆颢资产</div>
                <div class="icon" @click="this.controlTag">
                    <span>{{ num ? num : 0 }}</span
                    ><b>元</b>
                    <img src="../../../assets/images/icon.png" alt="" srcset="" :class="!show ? 'direction' : ''" v-if="ftype !== '3'" />
                </div>
            </div>
        </div>
        <div v-if="ftype !== '3'">
            <div class="wrap" v-if="show">
                <div class="box">
                    <div class="article" v-if="ftype == '1'">
                        <p>
                            喆颞持仓客户,扫码关注【钧山PEAKVEST】公众号。点击【钧山业务】-【资本市场】板块，喆颢官网。
                        </p>
                        <p>使用原投米APP注册手机号登陆查看资产</p>
                    </div>
                    <div class="article" v-if="ftype == '2'">
                        <p>
                            天瓴持仓客户,扫码关注【天瓴投资管理】公众号，点击【我的服务】板块进入。
                        </p>
                        <p>使用原认购预留手机号登录查看资产。</p>
                    </div>
                    <div class="code">
                        <!-- 钧山 -->
                        <img src="https://houyu-pic.oss-cn-beijing.aliyuncs.com/upload/20221205/21a2e98dc4365741680d2ddab78b99a7.png" alt="" v-if="ftype == 1" />
                        <!--天瓴  -->
                        <img src="https://houyu-pic.oss-cn-beijing.aliyuncs.com/upload/20221205/0ec68ba64c491f2b81d43896fcca2c58.png" alt="" v-if="ftype == 2" />
                    </div>

                    <div class="codetext" v-if="ftype == '2'">扫码关注【天瓴投资管理】公众号</div>
                    <div class="codetext" v-if="ftype == '1'">扫码关注【钧山PEAKVEST】公众号</div>
                    <div class="btn" @click="saveImg">保存图片</div>
                </div>
            </div>
        </div>
        <div class="tipA">了解更多，请联系您的专属顾问</div>
    </div>
</template>

<script>
import { callHandler } from "../../../utils/bridge";
export default {
    name: "About",
    data() {
        return {
            show: true,
            ftype: 0,
            num: 0
        };
    },
    created() {
        let params = this.$route.query;
        this.ftype = params.ftype;
        this.num = params.dataNumber;
    },
    methods: {
        saveImg() {
            // 钧山
            let picUrl = "https://houyu-pic.oss-cn-beijing.aliyuncs.com/upload/20221205/21a2e98dc4365741680d2ddab78b99a7.png";
            if (this.ftype === "2") {
                picUrl = "https://houyu-pic.oss-cn-beijing.aliyuncs.com/upload/20221205/0ec68ba64c491f2b81d43896fcca2c58.png";
            }
            callHandler("tbSaveImage", {
                imageType: "url",
                content: picUrl
            });
        },
        controlTag() {
            this.show = !this.show;
        }
    }
};
</script>
<style lang="less" scoped>
.other-Assets {
    height: 100vh;
    padding-top: 13px;
    background: #f7f8fa;
    // background: orange;
    border-radius: 24px;
    position: relative;
    .head {
        width: 375px;
        height: 43px;
        background: #fff;
        border-radius: 24px;
        position: absolute;
        left: 0;
        top: 12px;
        z-index: 2;

        .main {
            width: 343px;
            height: 43px;
            line-height: 43px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            // background: orange;
            div:nth-child(1) {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
            }
            div:nth-child(2) {
                font-size: 16px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #000000;
                display: flex;
                align-items: center;
                span {
                    font-size: 16px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    color: #000000;
                }
                b {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    padding-right: 4px;
                }
                img {
                    width: 12px;
                    height: 13px;
                    display: block;
                }
                .direction {
                    transform: rotate(180deg);
                }
            }
        }
    }
    .wrap {
        min-height: 43px;
        background: #fff;
        border-radius: 24px;
        padding: 44px 16px 16px 16px;
        .box {
            width: 319px;
            height: 233px;
            background: rgba(247, 248, 250, 0.7);
            border-radius: 8px;
            margin: 0 auto;
            padding: 18px 12px 17px 12px;
            .article {
                margin: 0 auto;
                text-align: justify;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #7c7c7c;
                line-height: 17px;
                margin-bottom: 16px;
            }
            .code {
                width: 100px;
                height: 100px;
                // background: orange;
                margin: 0 auto;
                margin-bottom: 8px;
                img {
                    width: 100%;
                }
            }
            .codetext {
                text-align: center;
                margin-bottom: 4px;
                height: 22px;
                line-height: 17px;
            }
            .btn {
                width: 100px;
                height: 32px;
                background: linear-gradient(90deg, #c4a06c 0%, #ead2a2 100%);
                border-radius: 29px;
                color: #fff;
                text-align: center;
                line-height: 32px;
                margin: 0 auto;
            }
        }
    }
}
.tipA {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #b3b3b3;
    text-align: center;
    position: absolute;
    bottom: 27px;
    left: 0;
    right: 0;
    margin: 0 auto;
}
</style>
